import { render, staticRenderFns } from "./treatmentPlanRep.vue?vue&type=template&id=1268c8d4&"
import script from "./treatmentPlanRep.vue?vue&type=script&lang=js&"
export * from "./treatmentPlanRep.vue?vue&type=script&lang=js&"
import style0 from "./treatmentPlanRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports